var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-item" },
    [
      _c(
        "a",
        {
          staticClass: "hamburguer",
          attrs: { href: "#" },
          on: { click: _vm.toggleMenu }
        },
        [
          _c("base-icon", {
            attrs: {
              src:
                "/static-appopensalud/img/icons/morillas-svg-icons/primary/hamburguer.svg",
              width: "40",
              height: "40",
              color: _vm.BLUE_COLOUR
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.dontDisplayDropdown
        ? _c("transition", { attrs: { name: "fade", appear: "" } }, [
            _vm.isOpen
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.hideMenu,
                        expression: "hideMenu"
                      }
                    ],
                    staticClass: "sub-menu"
                  },
                  [
                    _vm.showLanguageSelector
                      ? _c(
                          "div",
                          { staticClass: "menu-item-list" },
                          [
                            _c("lang-selector", {
                              staticClass: "d-inline-block mr-4",
                              staticStyle: { margin: "0px !important" },
                              attrs: { enablePortuguese: _vm.enablePortuguese }
                            }),
                            _vm._v(" "),
                            _c("hr")
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._t("menu-items")
                  ],
                  2
                )
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c5005932", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5005932","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/dropdown/HamburguerDropdown.vue
// module id = 2110
// module chunks = 120